<template>
    <div class="tr" v-if="editMode">
        <span class="td">{{index}}</span>
        <span class="td editable"><input name="serialNumber" type="text" v-model="device.serialNumber"
                                         v-validate.initial="{required: true, regex: /^[0-9a-f]+$/}"
        ><span class="error-tooltip" v-if="errors.first('serialNumber')"> {{errors.first('serialNumber')}}</span></span>
        <span class="td editable"><input name="name" type="text" v-model="device.name"
                                         v-validate.initial="'required'"></span>

        <span class="td editable"><MultiSelect :allow-empty="false"
                                               :options="availableShops"
                                               :searchable="true"
                                               @input="select"
                                               class="shop-select"
                                               label="name"
                                               track-by="id"
                                               :show-labels="false"
                                               v-model="selectedShop">
              <!-- @select="select"
               @remove="remove"-->
               </MultiSelect></span>
        <!--        <span class="td">Shops placeholder</span>-->
        <span class="td editable">
      <MultiSelect :allow-empty="false"
                   :options="options"
                   :searchable="false"
                   @input="changeBidirectional"
                   label="text"
                   track-by="value"
                   :show-labels="false"
                   v-model="selectedBidirectional">
      </MultiSelect></span>
        <span class="td non-editable">{{device.versionNumber}}</span>

        <span @click="changeState" class="td status non-editable">
            <font-awesome-icon class="active" icon="check-circle" size="lg" v-if="isActive"/>
            <font-awesome-icon class="disabled" icon="times-circle" size="lg" v-else>
            </font-awesome-icon>
        </span>
        <span class="td non-editable">
            {{device.lastActivation}}
       </span>
        <span class="td operations">
            <div class="operations-container">
            <button :class="{'invalidated': !validated}" :title="$t('general.edit')" @click="edit">
                                          <svg height="22" viewBox="0 -3 20 23" width="20"
                                               xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
            </button>
                            <button :title="$t('general.remove')">
                    <font-awesome-icon :class="{removed: removed}" @click="removeDevice" class="disabled"
                                       icon="times-circle"
                                       size="lg">

                </font-awesome-icon>
            </button>
            </div>
        </span>
    </div>
    <div :class="{modified: modified}" class="tr" v-else>
        <span class="td">{{index}}</span>
        <span class="td">{{device.serialNumber}}</span>
        <span class="td">{{device.name}}</span>

        <span class="td">{{selectedShop.name}}</span>
        <!--        <span class="td">Shops placeholder</span>-->
        <span class="td">{{device.bidirectional ? $t('general.yes') : $t('general.no')}}</span>
        <span class="td">{{device.versionNumber}}</span>

        <span class="td status">
            <font-awesome-icon class="active" icon="check-circle" size="lg" v-if="isActive"/>
            <font-awesome-icon class="disabled" icon="times-circle" size="lg" v-else>
            </font-awesome-icon>
        </span>
        <span class="td">   {{device.lastActivation}}</span>
        <span class="td operations">
            <div class="operations-container">
                            <button :title="$t('general.edit')" @click="edit">
                                          <svg height="22" viewBox="0 -3 20 23" width="20"
                                               xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
            </button>
            <button :title="$t('general.remove')">
                    <font-awesome-icon :class="{removed: removed}" @click="removeDevice" class="disabled"
                                       icon="times-circle"
                                       size="lg">

                </font-awesome-icon>
            </button>


</div>
        </span>
    </div>
</template>


<script>
import MultiSelect from 'vue-multiselect';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { SerialDuplicateError } from '@/api/user/erros';

const DevicesRepository = RepositoryFactory.get('devices');

export default {
  name: 'Device',
  components: {
    MultiSelect,
  },
  data() {
    return {
      selectedShop: { id: 0, label: 'loading' },
      availableShops: [],
      removed: false,
      editMode: '',
      modified: false,
      options: [
        {
          text: this.$t('general.yes'),
          value: true,
        },
        {
          text: this.$t('general.no'),
          value: false,
        },
      ],
      selectedBidirectional: '',
      initSerialNumber: '',
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
    possibleSalons: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.device.active;
    },
    validated() {
      return this.errors.items.length <= 0;
    },
  },

  mounted() {
    this.$validator.localize(this.$i18n.locale, {
      messages: {
        regex: field => this.$t('devices.validation.serialNumber'),
        required: field => this.$t('validation.requiredField'),
      },
    });
    const { token } = this.$store.getters;
    if (this.device.editMode) {
      this.editMode = this.device.editMode;
    } else {
      this.editMode = false;
    }
    this.availableShops = this.possibleSalons;
    if (this.device.id > 0) {
      if (this.availableShops.find(entry => entry.id === parseInt(this.device.shopId)) === undefined) {
        this.selectedShop = { id: -1, name: this.$t('devices.noSalon') };
      } else {
        this.selectedShop = this.availableShops.find(entry => entry.id === parseInt(this.device.shopId));
      }
    } else {
      this.selectedShop = this.availableShops[0];
      this.device.shopId = this.selectedShop.id;
    }
    if (this.device.bidirectional) {
      this.selectedBidirectional = {
        value: this.device.bidirectional,
        text: this.$t('general.yes'),
      };
    } else {
      this.selectedBidirectional = {
        value: this.device.bidirectional,
        text: this.$t('general.no'),
      };
    }
    this.initSerialNumber = this.device.serialNumber;
  },
  methods: {
    changeBidirectional() {
      this.device.bidirectional = this.selectedBidirectional.value;
    },
    select() {
      this.device.shopId = this.selectedShop.id;
    },
    changeState() {
      if (this.removed === true) {
        this.removed = false;
      } else {
        this.removed = true;
      }
    },
    removeDevice() {
      // this.device.editMode = false;
      if (this.device.id > 0) {
        if (this.removed) {
          this.removed = false;
          this.$emit('cancelRemoval', this.device.id);
        } else {
          this.removed = true;
          this.$emit('removal', this.device.id);
        }
      } else {
        this.$emit('delete', this.$vnode.key);
        if (this.device.editMode) {
          this.$emit('decrease');
        }
      }
    },
    edit() {
      this.$emit('edited', this.device);
      this.modified = true;
      if (this.editMode) {
        if (this.validated) {
          if (this.device.id < 0) {
            DevicesRepository.validateSerials(this.$store.getters.token, { serialNumber: this.device.serialNumber })
              .then((response) => {
                this.switchMode();
                this.$emit('removeError', this.device.id);
              })
              .catch((error) => {
                if (error instanceof SerialDuplicateError) {
                  this.$emit('serialValidationError', { serialNumber: this.device.serialNumber, id: this.device.id });
                }
              });
          } else if (this.device.serialNumber === this.initSerialNumber) {
            this.switchMode();
            this.$emit('removeError', this.device.id);
            this.$emit('edited', this.device);
          } else {
            DevicesRepository.validateSerials(this.$store.getters.token, { serialNumber: this.device.serialNumber })
              .then((response) => {
                this.switchMode();
                this.$emit('removeError', this.device.id);
                this.$emit('edited', this.device);
              })
              .catch((error) => {
                if (error instanceof SerialDuplicateError) {
                  this.$emit('serialValidationError', { serialNumber: this.device.serialNumber, id: this.device.id });
                }
              });
          }
        }
      } else {
        this.switchMode();
      }
    },
    switchMode() {
      this.editMode = !this.editMode;
      this.editModeSwitcher();
    },
    editModeSwitcher() {
      if (this.editMode) {
        this.$emit('increase');
      } else {
        this.$emit('decrease');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
    .invalidated {
        filter: grayscale(100%);
        cursor: default;
    }

    .operations-container {
        display: flex;
        align-items: center;
    }

    DIV.table {
        display: table;
    }

    FORM.tr, DIV.tr {
        display: table-row;
        /*border: 1px solid lightgray;*/
    }

    SPAN.td {
        display: table-cell;
        padding: 0;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        /* color: #878a94; */
        text-align: left;
        padding-left: 10px;
        position: relative;

        .multiselect__tag {
            border: none;
        }

        cursor: default;

        &.editable {
            border: 1px solid $peacock-blue;
            cursor: auto;
            padding-left: 0;
        }

        &:first-child {
            font-weight: 900;
            padding: 20px;
        }

        &:last-child {
            border-right: none;
        }

        input {
            border: none;
        }
    }

    .a {
        fill: #002678;
    }

    .b {
        fill: #fff;
    }

    svg {
        /*padding: 0 10px 0 20px;*/
    }

    .active {
        color: $peacock-blue;
    }

    .disabled {
        color: $marine-blue;
    }

    .td.status {
        text-align: center;
        padding-left: 0;
    }

    input {
        /* color: #878a94; */
        font-size: rem(14px);
        line-height: 19px;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: none;
    }

    .removed {
        color: red;
    }

    .operations {
        button {
            background: none;
            border: none;

        }
    }

    .non-editable {
        background-color: lighten(#878a94, 30%);
        cursor: default;
    }

    select {
        font-size: rem(14px);
        border: none;
        width: 100%;
    }

    .error-tooltip {
        border: 2px solid $red;
        position: absolute;
        bottom: -150%;
        width: 200px;
        color: $red;
        background-color: lighten($red, 40%);
        left: 0;
        z-index: 150;
        padding: 15px;
    }

    .modified {
        background-color: lighten(#878a94, 30%);
    }
</style>
